function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Widget from 'components/Widget';
import SummaryTableReport from '../SummaryTableReport';
import * as constants from '../../constants';
import messages from '../../messages';
var _React_Component;
class SummaryTableWidget extends (_React_Component = React.Component) {
    render() {
        return /*#__PURE__*/ _jsx(Widget, {
            widgetId: constants.SUMMARY_TABLE_REPORT_WIDGET,
            headerMessage: messages.headers.resultsSummary,
            isInProgress: this.props.isInProgress,
            className: this.props.className,
            children: /*#__PURE__*/ _jsx(SummaryTableReport, _object_spread({}, this.props))
        });
    }
}
_define_property(SummaryTableWidget, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readings: PropTypes.array,
    customRanges: PropTypes.array,
    isInProgress: PropTypes.bool,
    className: PropTypes.string
});
export default SummaryTableWidget;
